import { ListView } from "@repo/skapa";
import {
  ListViewItemWithActions,
  PopoverContainer,
  useOnClickOutside,
} from "@repo/ui";
import { type MouseEvent, type SVGProps, useRef, useState } from "react";
import { createPortal } from "react-dom";
import { usePopper } from "react-popper";

interface MenuItem {
  icon: (prefix?: string) => SVGProps<SVGElement>[];
  label: string;
  disabled?: boolean;
  onClick: (e?: MouseEvent) => void;
}

interface ContextMenuProps {
  menuItems: MenuItem[];
  isOpen: boolean;
  setIsOpen: (isOpen: boolean) => void;
  elRef: HTMLDivElement | null;
}
export const ContextMenu = ({
  elRef,
  setIsOpen,
  isOpen,
  menuItems,
}: ContextMenuProps) => {
  const ref = useRef<HTMLDivElement>(null);
  useOnClickOutside(ref, () => {
    setIsOpen(false);
  });
  const [menuRef, setMenuRef] = useState<HTMLDivElement | null>(null);
  const { styles, attributes } = usePopper(elRef, menuRef, {
    placement: "auto",
    modifiers: [{ name: "offset", options: { offset: [10, 10] } }],
  });

  if (!isOpen) {
    return null;
  }

  return createPortal(
    <PopoverContainer
      ref={(el: HTMLDivElement) => {
        setMenuRef(el);
      }}
      style={styles.popper}
      {...attributes.popper}
    >
      <div ref={ref}>
        <ListView id="task-menu-more">
          {menuItems.map((item) => (
            <ListViewItemWithActions
              key={`task-menu-item--${item.label}`}
              inset
              title={item.label}
              icon={item.icon}
              onClick={() => {
                setIsOpen(false);
                item.onClick();
              }}
              disabled={item.disabled ?? false}
              extraPadding
            />
          ))}
        </ListView>
      </div>
    </PopoverContainer>,
    document.querySelector("#popper-portal")!
  );
};
